export default {
  title: 'Warum dieses Bild neu generieren?',
  description: 'Hilf uns, die KI zu verbessern — was hat nicht gepasst?',
  reasons: {
    wrong_style: 'Falscher Stil',
    wrong_colors: 'Falsche Farben',
    wrong_food_item: 'Falsches Gericht',
    low_quality: 'Schlechte Qualität',
    doesnt_match_brand: 'Passt nicht zu meiner Marke',
    text_issues: 'Text oder Beschriftungen falsch',
    other: 'Sonstiges',
  },
  details_label: 'Noch etwas? (optional)',
  details_placeholder: 'Mehr Details helfen uns, dich besser zu verstehen…',
  cancel: 'Abbrechen',
  confirm: 'Neu generieren',
};
